import { css, SerializedStyles } from '@emotion/react'
import { InfoLabel, Tag } from 'bold-ui'
import { blue, gray, purple } from 'bold-ui/lib/styles/colors'
import { OrigemDadoEnum } from 'graphql/types.generated'

type Origem = { nome: string; style?: SerializedStyles }

export const OrigemDadoEnumRecord: Partial<Record<OrigemDadoEnum, Origem>> = {
  [OrigemDadoEnum.CDS]: { nome: 'CDS' },
  [OrigemDadoEnum.RAS_PEC]: {
    nome: 'RAS PEC',
    style: css`
      color: ${gray.c20};
      background-color: ${blue.c80};
    `,
  },
  [OrigemDadoEnum.AC]: {
    nome: 'App e-SUS AC',
    style: css`
      color: ${gray.c20};
      background-color: ${purple.c70};
    `,
  },
  [OrigemDadoEnum.SISTEMA_TERCEIRO]: {
    nome: 'Outros',
    style: css`
      color: ${gray.c20};
      background-color: ${gray.c80};
    `,
  },
}

interface OrigemRegistroInfoProps {
  origem: OrigemDadoEnum
}

export const OrigemRegistroInfo = (props: OrigemRegistroInfoProps) => {
  const { origem } = props

  const origemRecord = OrigemDadoEnumRecord[origem]

  return (
    <InfoLabel title='Origem do registro'>
      <Tag style={[styles.tag, origemRecord.style]} type='info'>
        {origemRecord.nome}
      </Tag>
    </InfoLabel>
  )
}

const styles = {
  tag: css`
    margin-top: 0.25rem;
  `,
}
